'use strict';

var sdk = require('./sdk.js');



exports.AbTestingSdk = sdk.AbTestingSdk;
//# sourceMappingURL=index.js.map
